export default {
      id: "logo-hsbc-usage",
      viewBox: "0 0 120 60",
      url: __webpack_public_path__ + "sprite.svg#logo-hsbc",
      toString: function () {
        return this.url;
      }
    }